export const en = {
  form: {
    first_name: 'First Name',
    last_name: 'Last Name',
    email: 'Email Address',
    phone: 'Phone Number',
    business_type: 'Business Type',
    first_name_placeholder: 'John',
    last_name_placeholder: 'Doe',
    email_placeholder: 'john@example.com',
    phone_placeholder: '+1 (555) 000-0000',
    business_types: {
      e_commerce: 'E-commerce',
      saas: 'SaaS',
      service_provider: 'Service Provider',
      local_business: 'Local Business',
      other: 'Other'
    }
  },
  analysis_form: {
    website: 'Website',
    website_placeholder: 'https://example.com',
    referral_source: 'How did you find us?',
    referral_source_placeholder: 'Select your referral source',
    challenges: 'Main Challenges',
    challenges_placeholder: 'What are your biggest marketing and automation challenges?',
    business_type_placeholder: 'Select your business type',
    submitting: 'Submitting...',
    submit: 'Get My Free Analysis',
    success_title: 'Thank you for your analysis request!',
    success_message: "We'll review your information and get back to you soon.",
    error_message: 'Failed to submit analysis request. Please try again.'
  },
  footer: {
    about: {
      title: 'About Us',
      description: 'Helping businesses grow through strategic marketing and intelligent automation solutions.'
    },
    legal: {
      title: 'Legal',
      imprint: 'Imprint',
      privacy: 'Privacy Policy'
    },
    contact: {
      title: 'Contact'
    },
    social: {
      title: 'Follow Us'
    },
    copyright: 'Simons Marketing Solutions. All rights reserved.'
  },
  language_switch: 'Switch language',
  meta: {
    description: 'Grow your business with our guaranteed marketing results and automation solutions. Get a free marketing analysis today.',
    home: {
      title: 'Marketing & Automation Agency | Simons Marketing Solutions',
      description: 'Transform your business with proven marketing strategies and smart automation. Get guaranteed results with our expert solutions.'
    },
    analysis: {
      title: 'Free Marketing Analysis | Simons Marketing Solutions',
      description: 'Get a free, comprehensive analysis of your marketing potential. Discover opportunities for growth and automation in your business.'
    }
  },
  free_analysis_page: {
    back: 'Back to Home',
    badge: 'Free Analysis',
    title: 'Get Your Free',
    title_highlight: 'Google Analysis',
    subtitle: 'Find out where your business stands on Google and discover what it takes to reach the top 3 in your area.',
    form_title: 'Tell Us About Your Business',
    form_subtitle: 'Fill in the details below and we will get back to you with a comprehensive analysis.',
    benefits_title: 'What You Will Get',
    benefits: {
      google_audit: {
        title: 'Full Google Presence Audit',
        description: 'We review your current Google Maps listing, rankings, and profile completeness.'
      },
      competitor: {
        title: 'Competitor Analysis',
        description: 'See how you stack up against the top-ranking businesses in your area.'
      },
      strategy_call: {
        title: 'Strategy Call',
        description: 'A one-on-one call to walk you through our findings and recommended next steps.'
      },
      no_obligation: {
        title: 'No Obligation',
        description: 'This analysis is completely free. No contracts, no commitments.'
      },
      quick_turnaround: {
        title: 'Quick Turnaround',
        description: 'Receive your analysis within 48 hours of submitting your details.'
      },
      actionable: {
        title: 'Actionable Insights',
        description: 'Walk away with clear, practical steps you can take immediately.'
      }
    }
  },
  simonsMarketing: {
    nav: {
      advantages: 'Advantages',
      process: 'Process',
      testimonials: 'Testimonials',
      guarantee: 'Guarantee',
      questions: 'Questions',
      free_analysis: 'Free Analysis'
    },
    hero: {
      badge: 'Google SEO',
      title_start: 'Top 3 on Google within 90 Days,',
      title_highlight: 'Guaranteed.',
      subtitle_line1: '75% of all search requests go to the top 3 results on Google.',
      subtitle_line2: 'And if you\'re not in the top 3, you\'re essentially',
      subtitle_highlight: 'invisible',
      cta_primary: 'Get Started',
      cta_secondary: 'See How It Works'
    },
    value_proposition: {
      badge: 'The Advantage',
      title_prefix: 'But',
      title_suffix: ', Is This Even Worth It?',
      features: {
        visibility: {
          title: 'Visibility',
          description: 'When potential customers search for businesses like yours, they find you first. Being in the top 3 means being the obvious choice in your area.'
        },
        free: {
          title: 'Free',
          description: 'Unlike paid ads that drain your budget every single month, Google Maps rankings deliver organic traffic without ongoing ad spend. Once you rank, the leads keep coming.'
        },
        long_term: {
          title: 'Long Term Strategy',
          description: 'This isn\'t a short-term hack. A strong Google Maps presence compounds over time, building trust, authority, and a steady stream of customers for years to come.'
        }
      }
    },
    testimonials: {
      badge: 'Testimonials',
      title_start: 'What Our Clients',
      title_highlight: 'Say',
      items: {
        anke: {
          content: 'I had no website and no idea how to change that. Simon just solved it. Exactly how I envisioned it. The result is a site that I manage myself today and that brings me more customers. And when I have questions, he is still there. Clear recommendation.',
          name: 'Anke D.',
          role: 'Anke Wohnambiente'
        },
        linda: {
          content: 'For my practice, visibility and presentation on the internet is of great importance to attract new patients. At first I was a bit skeptical, because you get so many offers. Simon managed to get my homepage ranked from the fourth page up to the first page in search results, and I have already received several new inquiries from interested patients. He also transferred my homepage to a new, much more affordable provider. Here too, I was able to save money. I can recommend him wholeheartedly.',
          name: 'L. K.',
          role: 'Naturopath'
        }
      }
    },
    process: {
      badge: 'How Does It Work?',
      title: 'It\'s Pretty',
      title_italic: 'easy.',
      steps: {
        free_analysis: {
          title: 'Free Analysis',
          description: 'Fill out the form for the free analysis.'
        },
        onboarding: {
          title: 'Onboarding',
          description: 'We\'ll hop on a call to see if we\'re a good match. If so, we\'ll send you detailed instructions showing how we get secure access to your profile.'
        },
        execution: {
          title: 'Execution',
          description: 'We walk through every step of the process with you so we don\'t just fill your calendar for weeks. Throughout our collaboration, you\'ll receive regular progress updates.'
        },
        what_works: {
          title: 'What works?',
          description: 'We track relevant data to see what actually works and adjust the strategy to get the most out of it for you.'
        }
      }
    },
    faq: {
      badge: 'FAQs',
      title_start: 'Frequently Asked',
      title_bold: 'Questions',
      items: {
        seo_vs_ads: {
          question: 'What is the difference between SEO and Google Ads?',
          answer: 'SEO (Search Engine Optimization) focuses on improving your organic search rankings through content optimization, technical improvements, and building authority. Google Ads is a paid advertising platform where you pay for each click. The key difference is sustainability: SEO builds long-term visibility that compounds over time, while Google Ads stops generating traffic the moment you stop paying. Our Google SEO service focuses on organic rankings that deliver ongoing results without recurring ad costs.'
        },
        which_companies: {
          question: 'Which companies do you work with?',
          answer: 'We work with local businesses across all industries that want to dominate their local market on Google. This includes dental practices, law firms, plumbers, electricians, real estate agents, auto repair shops, salons, and many more. If you have a physical location or serve a specific geographic area, our service is designed for you.'
        },
        time_invest: {
          question: 'How much time will I need to invest?',
          answer: 'Very little. During onboarding, you\'ll spend about 30 minutes providing us with the necessary information about your business. After that, we handle everything. You\'ll receive regular updates and reports, but the day-to-day optimization work is entirely managed by our team. Your time investment is minimal so you can focus on running your business.'
        },
        contract_terms: {
          question: 'What are the contract terms?',
          answer: 'We believe in earning your business through results, not locking you into long contracts. Our packages are designed to be straightforward and transparent. We\'ll discuss the specific terms during your free analysis call, where we\'ll recommend the best approach based on your market and goals.'
        },
        get_started: {
          question: 'How can we get started?',
          answer: 'Getting started is simple. Submit a free analysis for your current business and we\'ll then conduct the analysis of your current Google presence and schedule a call to walk you through our findings and recommended strategy. From there, we handle the entire process.'
        }
      }
    },
    guarantee: {
      badge: 'Our Guarantee',
      title: 'Guarantee',
      description: 'If we don\'t see improvements after 2 months, we\'ll keep working for free until we\'ve ranked your website on the first page of Google.'
    },
    pricing_cta: {
      title: 'Ready to Dominate Google?',
      subtitle: 'Stop losing customers to your competitors. Get your free analysis today and find out exactly what it takes to reach the top 3.',
      button: 'Get Your Free Analysis'
    },
    footer: {
      description: 'Helping local businesses dominate Google Maps and attract more customers through proven marketing strategies.',
      quick_links: 'Quick Links',
      contact: 'Contact',
      copyright: 'Simons Marketing Solutions. All rights reserved.'
    }
  }
} as const;
